(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pur-cart-upsell"] && !Shopify.designMode) return;
  try {
    
(() => {
  const messagesElement = document.getElementById('pur-cart-messages');
  if (!messagesElement) return;
  const messages = JSON.parse(messagesElement.textContent);
  const base = window.Shopify?.routes?.root || '/';
  const change = body => fetch(base + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
  document.querySelectorAll('[data-pur-cart-switch]').forEach(button => button.addEventListener('click', async () => {
    if (button.disabled) return;
    const originalLabel = button.textContent;
    const error = button.parentElement.querySelector('[data-pur-cart-error]');
    let original,converted;
    button.disabled = true;
    button.textContent = messages.working;
    error.hidden = true;
    try {
      const response = await fetch(base+'cart.js',{headers:{'Accept':'application/json'}});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      original = cart.items.find(item => item.key === button.dataset.key && !item.selling_plan_allocation);
      if (!original) { location.assign(base+'cart'); return; }
      const changed = await change({id:original.key,quantity:original.quantity,selling_plan:Number(button.dataset.plan)});
      if (!changed.ok) throw new Error();
      const updated = await changed.json();
      converted = updated.items.find(item => item.variant_id === original.variant_id && String(item.selling_plan_allocation?.selling_plan?.id) === button.dataset.plan);
      if (!converted) throw new Error();
      if (!updated.items.some(item => String(item.variant_id) === button.dataset.bottle)) {
        const added = await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:button.dataset.bottle,quantity:1,properties:{_PURLaunchGift:'PURLAUNCH'}}]})});
        if (!added.ok) throw new Error();
      }
      location.assign(base+'discount/PURLAUNCH?redirect='+encodeURIComponent(base+'cart'));
    } catch {
      if (converted) {
        try { await change({id:converted.key,quantity:original.quantity,selling_plan:null}); } catch {}
        location.assign(base+'cart');
        return;
      }
      button.disabled = false;
      button.textContent = originalLabel;
      error.textContent = messages.error;
      error.hidden = false;
    }
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pur-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var offer = document.querySelector('#pur-offer');
  var bar = document.querySelector('.pur-mobile-bar');
  if (!offer || !bar || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    bar.dataset.active = !entry.isIntersecting && entry.boundingClientRect.bottom < 0 ? 'true' : 'false';
  }, { threshold: 0 });
  observer.observe(offer);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pur-subscription-launch"] && !Shopify.designMode) return;
  try {
    
(() => {
  const dialog = document.getElementById('pur-launch-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'pur-launch-dismissed-v1';
  let opener;
  const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const open = (element) => {
    if (dialog.open || document.querySelector('dialog[open]') || document.querySelector('input:focus,textarea:focus,select:focus')) return;
    opener = element || document.activeElement;
    dialog.showModal();
    remember();
  };
  document.querySelectorAll('[data-pur-launch-open]').forEach(button => button.addEventListener('click', () => open(button)));
  document.querySelectorAll('[data-pur-launch-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => { remember(); if (opener instanceof HTMLElement) opener.focus(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  if (dialog.dataset.autoPopup === 'true' && !dismissed() && !window.Shopify?.designMode && !location.pathname.includes('/cart')) {
    setTimeout(() => { if (!dismissed() && document.visibilityState === 'visible') open(); }, Number(dialog.dataset.popupDelay || 8) * 1000);
  }
  const messages = JSON.parse(document.getElementById('pur-launch-messages').textContent);
  const base = window.Shopify?.routes?.root || '/';
  document.querySelectorAll('[data-pur-launch-add]').forEach(button => button.addEventListener('click', async () => {
    if (button.disabled) return;
    const label = button.textContent;
    const error = button.parentElement.querySelector('[data-pur-launch-error]');
    button.disabled = true;
    button.textContent = messages.working;
    if (error) error.hidden = true;
    try {
      const response = await fetch(base + 'cart.js', {headers:{'Accept':'application/json'}});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const items = [];
      const hasSubscription = cart.items.some(item => String(item.variant_id) === button.dataset.pouch && String(item.selling_plan_allocation?.selling_plan?.id) === button.dataset.plan);
      const hasBottle = cart.items.some(item => String(item.variant_id) === button.dataset.bottle);
      if (!hasSubscription) items.push({id:button.dataset.pouch,quantity:1,selling_plan:button.dataset.plan});
      if (!hasBottle) items.push({id:button.dataset.bottle,quantity:1,properties:{_PURLaunchGift:'PURLAUNCH'}});
      if (items.length) {
        const added = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!added.ok) throw new Error();
      }
      location.assign(base + 'discount/PURLAUNCH?redirect=' + encodeURIComponent(base + 'cart'));
    } catch {
      button.disabled = false;
      button.textContent = label;
      if (error) { error.textContent = messages.error; error.hidden = false; }
    }
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-article"]) return;
  try {
    
var purArticleUrl = new URL(window.location.href);
if (
  purArticleUrl.searchParams.get('customer_posted') === 'true' &&
  document.querySelector('.pur-article-capture')
) {
  purArticleUrl.searchParams.delete('customer_posted');
  window.history.replaceState({}, '', purArticleUrl.pathname + purArticleUrl.search + purArticleUrl.hash);
}

if (!document.documentElement.dataset.purArticleTrackingBound) {
  document.documentElement.dataset.purArticleTrackingBound = 'true';
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-pur-article-product]');
    if (!link) return;
    var eventData = {
      article_slug: link.dataset.articleSlug,
      page_path: window.location.pathname,
      link_url: link.href
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'article_product_click', eventData);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'article_product_click' }, eventData));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
